<template>
  <div class="googleDocActions">
    <button type="button" class="meetingPaneAction" @click="$emit('fullscreen')">
      <feather-icon icon="Maximize2Icon" svgClasses="w-4 h-4" />
      Fullscreen
    </button>
    <a
      :href="url"
      target="_blank"
      rel="noopener noreferrer"
      class="meetingPaneAction"
    >
      <feather-icon icon="ExternalLinkIcon" svgClasses="w-4 h-4" />
      Open in Google
    </a>
    <button type="button" class="meetingPaneAction" @click="qrPopupActive = true">
      <feather-icon icon="GridIcon" svgClasses="w-4 h-4" />
      Share with QR
    </button>

    <vs-popup
      :active.sync="qrPopupActive"
      title="Scan to open document"
      class="googleDocQrPopup"
    >
      <div class="googleDocQrBody">
        <qrcode :value="url" :size="256" level="M" />
        <p class="googleDocUrl mt-3">
          <a :href="url" target="_blank" rel="noopener noreferrer">{{ url }}</a>
        </p>
        <vs-button class="mt-2" color="primary" @click="copyLink">Copy link</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  name: "GoogleDocActions",
  components: { qrcode: QrcodeVue },
  props: {
    url: { type: String, required: true }
  },
  data() {
    return {
      qrPopupActive: false
    };
  },
  methods: {
    async copyLink() {
      try {
        await navigator.clipboard.writeText(this.url);
        this.$vs.notify({ color: "success", title: "Copied", text: "Link copied to clipboard" });
      } catch (e) {
        this.$vs.notify({ color: "danger", title: "Could not copy", text: e.message });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.googleDocActions {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.googleDocQrBody {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 8px 4px 4px;
}

.googleDocUrl {
  word-break: break-all;
  font-size: 0.8rem;
  max-width: 320px;
}
</style>

<style lang="scss">
.meetingPaneAction {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.85rem;
  font-weight: 400;
  line-height: 1.2;
  font-family: inherit;
  text-decoration: none;
  background: none;
  border: 0;
  padding: 0;
  cursor: pointer;
  color: inherit;
}
.meetingPaneAction:hover {
  text-decoration: underline;
}
</style>
